/** @format */

const formatPlace = place => ({
	_id: place._id,
	rut: place.rut,
	name: place.name,
	cliente: place.cliente,
	services: place.services,
	documents: place.documents,
	typeDocuments: place.typeDocuments,
	owner: `${place.ownerId.name} ${place.ownerId.lastName}`,
	ownerEmail: place.ownerId.email,
	ownerId: place.ownerId._id,
	geofence: place.geofence,
	timeConfiguration: place.timeConfiguration,
	lodgings: place.lodgings,
	address: place.address,
	email: place.email,
	direction: place.direction,
	city: place.city,
	password: place.password,
	passwordDocuments: place.passwordDocuments,
	region: place.region,
	nombreSolicitante: place.nombreSolicitante,
	rutSolicitante: place.rutSolicitante,
	direccionSolicitante: place.direccionSolicitante,
	comunaSolicitante: place.comunaSolicitante,
	direccionPropietario: place.direccionPropietario,
	satisfactionSurvey: place.satisfactionSurvey,
	type: place.type,
	temporalOTs: place.temporalOTs,
	frecuenciaCorreos: place.frecuenciaCorreos,
	horaCorreos: place.horaCorreos,
});

export default formatPlace;
